import { StyledLoginContainer } from './style';
import useQueryApiClient from '../../../utils/useQueryApiClient';
import parse from 'html-react-parser';

interface LoginStyleContainerProps {
  children: React.ReactNode;
}

export const LoginStyleContainer = ({ children }: LoginStyleContainerProps) => {
  const { data, isLoading } = useQueryApiClient({
    request: {
      url: `/api/v2/classifiers/type/AUTHENTICATION/AUTHENTICATION`,
    },
  });

  if (isLoading) {
    return <></>;
  }

  return (
    <StyledLoginContainer>
      <div className={'image'}></div>
      <div className={'information'}>
        {data?.value ? parse(data?.value) : ''}
      </div>
      <div className={'content'}>{children}</div>
    </StyledLoginContainer>
  );
};
